<template>
  <main>
    <Banner></Banner>
    <ProdutosCategorias></ProdutosCategorias>
    <ComoFunciona></ComoFunciona>
    <QuemSomos></QuemSomos>
    <NossosServicos></NossosServicos>
    <MarcasParceiras></MarcasParceiras>
  </main>
</template>

<script>
import Banner from 'Homepage/home/Banner.vue';
import ProdutosCategorias from 'Homepage/home/ProdutosCategorias.vue';
import ComoFunciona from 'Homepage/home/ComoFunciona.vue';
import QuemSomos from 'Homepage/home/QuemSomos.vue';
import NossosServicos from 'Homepage/common/NossosServicos.vue';
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Layout',
  components: {
    Banner,
    ProdutosCategorias,
    ComoFunciona,
    QuemSomos,
    NossosServicos,
    MarcasParceiras,
  },
};

</script>

<style scoped>

</style>
